import React from "react";
import TableData from "./Table/TableData";
export default function Warehousestocklist() {
  return (
    <div>
      <div className="mt-8 flex flex-wrap justify-center ">
          <div className="tabelcontainer flex-auto mt-8 overflow-auto">
            <TableData />
          </div>
      </div>
    </div>
  );
}
